<template>
    <div class="search-results-site-links">
        <div v-if="showNew && siteLinksNewModels[brand]" class="search-results-site-links__new-cars">
            <p class="search-results-site-links__title">
                <a :href="`/${brand}/new`">
                    <span v-if="siteLinksNewModels[brand]['has_vans'] === true">{{ brand === "ds" ? "DS" : manufacturer }} New Cars & Vans</span>
                    <span v-else>{{ brand === "ds" ? "DS" : manufacturer }} New Cars</span>
                </a>
            </p>

            <ul class="ul__no-bullet">
                <li v-for="model in siteLinksNewModels[brand]['data']" class="search-results-site-links__li">
                    <a class="search-results-site-links__a" :href="`/${brand}/new/${model['url_model']}`">
                        {{ model["short_name"] }}
                    </a>
                </li>
            </ul>
        </div>

        <div v-if="siteLinksUsedVehicles[manufacturer]" class="search-results-site-links__used-cars">
            <p class="search-results-site-links__title">
                <router-link :to="`/${brand}/used-vehicles`">
                    <strong> {{ manufacturer }} Used Vehicles </strong>
                </router-link>
            </p>
            <ul class="ul__no-bullet">
                <li v-for="model in siteLinksUsedVehicles[manufacturer]" class="search-results-site-links__li">
                    <a v-if="model['manufacturer_slug'] && model['slug']" class="search-results-site-links__a" :href="`/${model['manufacturer_slug']}/used-vehicles/${model['slug']}`">
                        {{ model["model"] }}
                    </a>
                    <a v-else class="search-results-site-links__a" :href="`/${brand}/used-vehicles/results?model=${encodeURIComponent(model['model'])}`">
                        {{ model["model"] }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import GetManufacturerFromBrand from "../../api/GetManufacturerFromBrand";

export default {
    props: {
        showNew: {
            required: false,
            default: true,
        },
        brand: {
            required: false,
            default: '',
        }
    },
    computed: {
        ...mapState("Layout", ["siteLinksNewModels", "siteLinksUsedVehicles"]),
        manufacturer() {
            return GetManufacturerFromBrand(this.brand);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/redesign/variables";

.search-results-site-links {
    padding-bottom: 40px;

    @media (min-width: 768px) {
        grid-column: 2/3;
    }

    &__new-cars {
        padding-bottom: 15px;
    }

    &__used-cars {
        padding-top: 15px;
    }
    &__title {
        line-height: 37px;
        color: $navy-blue;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: .3em;
        text-transform: capitalize;

        &--upper {
            text-transform: uppercase;
        }

        a {
            line-height: 37px;
            color: $navy-blue;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: .3em;
        }
    }

    & ul {
        padding-left: 0;
        margin-top: .3em;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: repeat(auto-fill, 1fr);
        gap: 0 30px;

        @media (min-width: $screen-sm) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media (min-width: 891px) {
            grid-template-columns: repeat(3, 1fr);
        }

        @media (min-width: $screen-lg) {
            grid-template-columns: repeat(4, 1fr);
        }
    }

        &__li {
        list-style-type: none;
        font-size: 16px;
        line-height: 37px;
        text-transform: capitalize;
    }

    &__a {
        color: $navy-blue;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Layout/SiteLinks.vue